import React, { useLayoutEffect, useRef, useState } from 'react';
import ViewLinkButton from '../ViewLinkButton/ViewLinkButton';
import styles from './ExpandableFupText.module.css';

interface ExpandableFupTextProps {
  text?: string;
  children?: React.ReactNode;
  contentKey?: string;
  className?: string;
}

const ExpandableFupText: React.FC<ExpandableFupTextProps> = ({
  text,
  children,
  contentKey = text ?? '',
  className = '',
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);

  useLayoutEffect(() => {
    const element = contentRef.current;
    if (!element || expanded) {
      setIsTruncated(false);
      return undefined;
    }

    const checkTruncation = () => {
      setIsTruncated(element.scrollHeight > element.clientHeight + 1);
    };

    checkTruncation();

    const observer = new ResizeObserver(checkTruncation);
    observer.observe(element);

    return () => observer.disconnect();
  }, [contentKey, expanded]);

  return (
    <div className={[styles['expandable-fup-text'], className].filter(Boolean).join(' ')}>
      <div
        ref={contentRef}
        className={expanded ? styles['fup-text-expanded'] : styles['fup-text']}
      >
        {children ?? text}
      </div>
      {isTruncated && !expanded && (
        <ViewLinkButton
          label="Ver mais"
          onClick={() => setExpanded(true)}
        />
      )}
    </div>
  );
};

export default ExpandableFupText;
